<template>
  <div class="page-container">
    <el-row :gutter="20">
      <el-col :span="16">
        <!-- 展品内容信息卡片 -->
        <div class="page-card">
          <!-- 页头 -->
          <div class="page-card__header">
            <el-row>
              <el-col :span="4">展品内容信息</el-col>
              <el-col :span="20" style="text-align: right">
                <el-button round size="small" @click="updateContent">修改</el-button>
              </el-col>
            </el-row>
          </div>

          <!-- 内容展示 -->
          <div class="page-card__body" v-if="contentShow">
            <div>
              <el-image
                src="https://axhub.im/pro/f170dd528588df3c/images/%E5%B1%95%E4%BC%9A%E7%AE%A1%E7%90%86-%E5%86%85%E5%AE%B9%E4%BF%A1%E6%81%AF/u3330.jpg"></el-image>
            </div>
            <div style="line-height: 50px; font-size: 20px; font-weight: bold">
              紧固件高端研讨会
            </div>
            <div style="text-align: left; line-height: 30px; font-size: 14px">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.
              Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar
              sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
              Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin
              sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
              euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.
              Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes,
              nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci,
              sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </div>
          </div>

          <!-- 表单编辑 -->
          <div class="page-card__body" v-else>
            <div>
              <el-image
                src="https://axhub.im/pro/f170dd528588df3c/images/%E5%B1%95%E4%BC%9A%E7%AE%A1%E7%90%86-%E5%86%85%E5%AE%B9%E4%BF%A1%E6%81%AF/u3330.jpg"></el-image>
            </div>
            <div>
              <el-form>
                <el-form-item label="展会标题：">
                  <el-input placeholder="输入展会标题" v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="内容信息：">
                </el-form-item>
                <vue-editor v-model="form.content"></vue-editor>
                <div style="margin: 20px 0">
                  <el-button type="primary" round>提交</el-button>
                  <el-button round @click="updateContent">取消修改</el-button>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </el-col>

      <el-col :span="8">
        <!-- 手机端展示样例卡片 -->
        <div class="page-card">
          <!-- 页头 -->
          <div class="page-card__header">
            展品内容信息-手机端展示样例
          </div>

          <!-- 样例内容 -->
          <div class="page-card__body">
            <div>
              <el-image
                src="https://axhub.im/pro/f170dd528588df3c/images/%E5%B1%95%E4%BC%9A%E7%AE%A1%E7%90%86-%E5%86%85%E5%AE%B9%E4%BF%A1%E6%81%AF/u3330.jpg"></el-image>
            </div>
            <div style="line-height: 50px; font-size: 20px; font-weight: bold">
              紧固件高端研讨会
            </div>
            <div style="text-align: left; line-height: 30px; font-size: 14px">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.
              Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar
              sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
              Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin
              sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
              euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.
              Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes,
              nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci,
              sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {VueEditor} from "vue2-editor";

export default {
  name: "eventContent",
  data() {
    return {
      contentShow: true,
      form: {
        title: '',
        content: '',
      }
    }
  },
  methods: {
    // 切换编辑/展示状态
    updateContent() {
      this.contentShow = this.contentShow === true ? false : true
    },
  },
  components: {
    VueEditor
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/eventContent.vue